import { useEffect } from "react"

/**
 * useDocumentTitle — set `document.title` for the current route and restore the
 * previous title on unmount.
 *
 * The Next app set per-route titles via `export const metadata`. There is no
 * `metadata` export in a Vite/react-router app, so each auth page calls this to
 * keep title parity ("Sign in · Badminton Warriors", etc.).
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
}
